import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import Picker from '../../containers/picker';
import PickerContainer from '../../blocks/picker-container';
import Cta from '../../containers/cta';
import PromoAndButtonModalWindow from '../../blocks/promo-and-button-modal-window';

const PickerBlock = props => <Picker {...props} />;
PickerBlock.displayName = 'Picker';

export default withDynamicComponents({
  componentWhitelist: [
    PickerContainer,
    Cta,
    PromoAndButtonModalWindow,
  ],
  mapInputToOutput: [
    ['categories', 'categories'],
    ['cta', 'cta'],
  ],
})(PickerBlock);



// WEBPACK FOOTER //
// ./src/blocks/picker/index.jsx